<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.99625 5.99777H21.0037" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.0021 12.0002H2.99625" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.99625 18.0026H13.0004" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
